"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iaJsonMockValue = void 0;
exports.iaJsonMockValue = {
    EntityId: '1508923415937_49803',
    Fussbreite: { Unit: 'mm', Value: 3.4 },
    IABodenH: { Unit: 'mm', Value: 3.4 },
    IAHKB: { Unit: 'mm', Value: 0 },
    IAHKBOT: { Unit: 'mm', Value: 0 },
    IAHKDist: { Unit: 'mm', Value: 0 },
    IAHKH: { Unit: 'mm', Value: 0 },
    IAHKHeight: { Unit: 'mm', Value: 0 },
    IAHKOLB: { Unit: 'mm', Value: 0 },
    IAHKOLOB: { Unit: 'mm', Value: 0 },
    IAHKOLOH: { Unit: 'mm', Value: 0 },
    IAHKOLUB: { Unit: 'mm', Value: 0 },
    IAHKOLUH: { Unit: 'mm', Value: 0 },
    IAHKOLUH_Rounded: false,
    IAHKORB: { Unit: 'mm', Value: 0 },
    IAHKOROB: { Unit: 'mm', Value: 0 },
    IAHKORUB: { Unit: 'mm', Value: 0 },
    IAHKRep: 0,
    IAHKULB: { Unit: 'mm', Value: 0 },
    IAHKULOB: { Unit: 'mm', Value: 0 },
    IAHKULOH: { Unit: 'mm', Value: 0 },
    IAHKULOH_Rounded: false,
    IAHKULUB: { Unit: 'mm', Value: 0 },
    IAHKULUH: { Unit: 'mm', Value: 0 },
    IAHKURB: { Unit: 'mm', Value: 0 },
    IAHKUROB: { Unit: 'mm', Value: 0 },
    IAHKURUB: { Unit: 'mm', Value: 0 },
    IAKisteHO: { Unit: 'mm', Value: 0 },
    IAKisteHU: { Unit: 'mm', Value: 0 },
    IAUebermass: { Unit: 'mm', Value: 0 },
    IAwmm: { Unit: 'mm', Value: 150 },
    LocalTransform: [1, 0, 0, 1, 0, 0],
    Id: 3573,
    ArtNr: { DE: '321.150', US: '321-150' },
    ArtNrExists: true,
    ArtNrGenerated: '321.150',
    Bezeichnung: {
        'de-DE': 'Einsteckboden, montiert',
        'hu-HU': 'Betett polc, szerelt',
        'en-US': 'Full-width shelf, assembled ',
        'zh-TW': '全寬水準分隔片，裝配件',
        'ko-KR': '전폭 가로분리대, 조립',
        'es-ES': 'Base insertable, montada',
        'zh-CN': '全宽水平分隔片，装配件',
        'it-IT': 'Separatore orizzontale a piena larghezza, montato',
        'pl-PL': 'Półka o pełnej szerokości, zmontowana',
        'nl-NL': 'Tussenschot met maximale breedte, gemonteerd',
        'pt-PT': 'Travessa longitudinal, montada',
        'sv-SE': 'Hyllplan, monterat',
        'da-DK': 'Hylde i fuld bredde, samlet',
        'cs-CZ': 'Příčka v plné šíři, sestavená',
        'fr-FR': 'Fond amovible, monté',
        'en-GB': 'Full-width shelf, assembled',
        'ja-JP': '貫通型棚板、エナジーチェーンに組付け',
    },
    Artikeltyp: 2400,
    Kind: 'Einsteckboden',
    BestTyp: 300,
    KetteSerieRef: [
        { Id: 3402, Kuerzel: '340', Artikeltyp: 2400 },
        { Id: 3712, Kuerzel: '350', Artikeltyp: 2400 },
        { Id: 4777, Kuerzel: '3400', Artikeltyp: 2400 },
        { Id: 4891, Kuerzel: '3450', Artikeltyp: 2400 },
        { Id: 4980, Kuerzel: '3500', Artikeltyp: 2400 },
        { Id: 5428, Kuerzel: '167', Artikeltyp: 2400 },
        { Id: 5563, Kuerzel: '168', Artikeltyp: 2400 },
        { Id: 5875, Kuerzel: '68', Artikeltyp: 2400 },
        { Id: 26666, Kuerzel: 'E6.52', Artikeltyp: 2400 },
        { Id: 26800, Kuerzel: 'E6.62', Artikeltyp: 2400 },
        { Id: 38489, Kuerzel: '3480', Artikeltyp: 2400 },
    ],
    KetteRef: [
        3439, 3440, 3441, 3442, 3443, 3444, 3445, 3749, 3750, 3751, 3752, 3753, 3754, 3755, 4814, 4815, 4816, 4817, 4818,
        4819, 4820, 4906, 4935, 4936, 4937, 4938, 5017, 5018, 5019, 5020, 5021, 5022, 5023, 5470, 5471, 5472, 5473, 5474,
        5475, 5476, 5477, 5605, 5606, 5607, 5608, 5609, 5610, 5611, 5612, 5917, 5918, 5919, 5920, 5921, 5922, 5923, 5924,
        26703, 26704, 26705, 26706, 26707, 26856, 26857, 26858, 26859, 26860, 26861, 46456, 46462, 46463, 46464, 46465,
        59527, 59537, 68064, 68074,
    ],
    Breite: { Unit: 'mm', Value: 150 },
    Montiert: true,
    Color: '0',
    PerNthKettenglied: 2,
    StartingAtNthKettenglied: 1,
};
//# sourceMappingURL=iaJsonMockValue.js.map